import classNames from 'classnames';
import React from 'react';

import { CreditCardService } from '@/domain/card';

import { Card, CardType, CreditCard } from '@generated-types';

import './CustomerCard.scss';

interface CustomerCardProps {
    card: Card | CreditCard;
}

const showCardImage = (card: Card | CreditCard) => {
    if (CreditCardService.isCreditCard(card)) {
        return true;
    }
    return (card.product !== undefined && card.type === CardType.CREDIT) || card.bankRegistrationNumber.length > 0;
};

const CardImageDisplay = ({ card }: CustomerCardProps) => {
    if (!showCardImage(card)) {
        return null;
    }

    const isCreditCard = CreditCardService.isCreditCard(card);

    return (
        <img
            className="card-image"
            src={card.imagePath || '/-/media/fellesbilder/kortdesign/kredittkort/gold-visa.png'}
            alt={!isCreditCard && card.type === CardType.DEBIT ? 'Bankkort' : 'Kredittkort'}
        />
    );
};

export default ({ card }: CustomerCardProps) => {
    return (
        <section
            aria-label="Kortinformasjon"
            className={classNames('customer-card', '-normal', {
                '-has-image': showCardImage(card),
            })}
        >
            <CardImageDisplay card={card} />
        </section>
    );
};
